import { Button } from '@/components/atoms/button';

/**
 * Shown in place of a charge's price when its service-fee quote failed to
 * load. Without the quote the operator can't see what the customer will
 * actually be charged (a card's fee, a bank debit's discount), so the charge
 * stays blocked until a retry succeeds.
 */
export function ServiceFeeQuoteUnavailable({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-2 rounded-md border border-destructive/40 px-3 py-2 text-sm text-destructive"
    >
      <span>Couldn't load the price for this payment method, so it can't be charged yet.</span>
      <Button type="button" variant="outline" size="sm" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
